<template>
  <section id="dashboard">
    <!-- Welcome Card -->
    <v-container class="fill-height">
      <!-- Select Filter -->
      <!-- <v-row justify="end" align="center">
        <v-col cols="4" md="auto" class="text-right pr-0">
          <small class="font-weight-medium">Colas:</small>
        </v-col>

        <v-col cols="8" md="auto">
          <v-switch
            v-model="QueueSearch"
            inset
            @change="requestDashboard"
          ></v-switch>
        </v-col>

        <v-col cols="4" md="auto" class="text-right">
          <small class="font-weight-medium">Mostrar por:</small>
        </v-col>

        <v-col cols="8" md="auto" lg="2">
          <v-select
            :disabled="!render"
            :items="DateItems"
            v-model="DateSearch"
            filled
            rounded
            single-line
            dense
            class="rounded-small"
            hide-details
            @change="requestDashboard"
          ></v-select>
        </v-col>
      </v-row> -->

      <!-- <v-row>
        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart1"
              type="area"
              :options="optionsMiniCardsAreaIncoming"
              :series="seriesMiniCardIncomingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart2"
              type="bar"
              :options="optionsMiniCardsBarIncoming"
              :series="seriesMiniCardIncomingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart3"
              type="area"
              :options="optionsMiniCardsAreaOutgoing"
              :series="seriesMiniCardOutgoingArea"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="shadow-5 py-1" v-if="render">
            <apexchart
              ref="chart4"
              type="bar"
              :options="optionsMiniCardsBarOutgoing"
              :series="seriesMiniCardOutgoingBar"
            ></apexchart>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="image"
            height="150"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row> -->

      <!-- <v-row align="center">
        <v-col cols="12" md="5">
          <v-card class="shadow-5" v-if="render" style="height: inehit;">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Total de llamadas: {{ totalCalls }}
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart5"
                type="donut"
                :options="optionsDonutCalls"
                :series="serieDonut"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" md="7">
          <v-card class="shadow-5" v-if="render">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Distribución de llamadas por tiempo
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart6"
                type="line"
                :options="optionsLine"
                :series="serieLine"
              ></apexchart>
            </v-card-text>
          </v-card>

          <v-skeleton-loader
            v-else
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row> -->

      <v-row>
        <!-- <v-col cols="12" md="6">
          <v-skeleton-loader
            :loading="!render"
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
            <v-card class="shadow-5">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Llamadas entrantes por extensión: {{ totalIncomingCalls }}
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart7"
                  type="bar"
                  :options="optionsBarIncomingCalls"
                  :series="barIncomingCalls"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col> -->

        <!-- <v-col cols="12" md="6">
          <v-skeleton-loader
            :loading="!render"
            transition="scale-transition"
            class="mx-auto"
            type="card"
          >
            <v-card class="shadow-5">
              <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Llamadas salientes por extensión: {{ totalOutgoingCalls }}
              </v-card-title>
              <v-card-text>
                <apexchart
                  ref="chart8"
                  type="bar"
                  :options="optionsBarOutgoingCalls"
                  :series="barOutgoingCalls"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-col> -->

        <v-col cols="12" md="3">
          <v-card class="shadow-5">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Clientes
            </v-card-title>
            <v-card-text>
              <v-chip class="ma-2" color="transparent" label>
                <v-icon x-large color="success" left>
                  mdi-circle-small
                </v-icon>
                Activos: {{ dashboard_client.count_client[0].enable }}
              </v-chip>

              <br />

              <v-chip class="ma-2" color="transparent" label>
                <v-icon x-large color="error" left>
                  mdi-circle-small
                </v-icon>
                Inactivos: {{ dashboard_client.count_client[0].disabled }}
              </v-chip>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="9">
          <v-card class="shadow-5">
            <!-- <v-card-title
                class="title text--primary"
                style="word-break: normal; line-height: normal;"
              >
                Llamadas salientes por extensión: {{ totalOutgoingCalls }}
              </v-card-title> -->
            <v-card-text>
              <v-data-table
                dense
                :headers="dashboard_client_headers"
                :items="dashboard_client.client_users"
                :items-per-page="5"
              ></v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import axios from "axios";

export default {
  inject: ["theme"],

  data() {
    return {
      render: false,
      userData: {},
      DateItems: ["Hoy", "Ayer", "Mes Actual", "Mes Anterior"],
      QueueSearch: false,
      DateSearch: "Hoy",
      // CONFIGURACIONES PARA GRÁFICAS
      totalCalls: 0,
      totalOutgoingCalls: 0,
      totalIncomingCalls: 0,
      optionsMiniCardsAreaIncoming: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Llamadas entrantes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#00BCD4"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionsMiniCardsAreaOutgoing: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Llamadas salientes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#2196F3"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },

      optionsMiniCardsBarIncoming: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Extensiones entrantes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#625FA4"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionsMiniCardsBarOutgoing: {
        chart: {
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        title: {
          text: 0,
          offsetX: 20,
          offsetY: 10,
          style: {
            fontSize: "24px",
            fontFamily: "Poppins",
          },
        },
        subtitle: {
          text: "Extensiones salientes",
          offsetX: 20,
          offsetY: 42,
          style: {
            fontSize: "13px",
            fontFamily: "Poppins",
          },
        },
        colors: ["#AB47BC"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            inverseColors: false,
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [50, 100],
          },
        },
        xaxis: {
          categories: [],
        },
      },

      optionsDonutCalls: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        labels: ["Entrantes", "Salientes"],
      },

      optionsBarIncomingCalls: {
        xaxis: {
          categories: [],
        },
        fill: {
          //   colors: ["#6D71F9"],
          colors: ["#008FFB"],
        },
      },
      optionsBarOutgoingCalls: {
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#00E396"],
          //   colors: ["#FEB019"],
        },
      },

      optionsLine: {
        theme: {
          mode: "light",
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
          tickPlacement: "on",
        },
        colors: ["#FEB019", "#008FFB", "#00E396"],
      },

      // DATOS PARA GRÁFICAS
      serieDonut: [0, 0],

      serieLine: [
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      barIncomingCalls: [
        {
          name: "series-1",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      barOutgoingCalls: [
        {
          name: "series-1",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      seriesMiniCardIncomingArea: [
        {
          name: "Llamadas entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesMiniCardOutgoingArea: [
        {
          name: "Llamadas salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      seriesMiniCardIncomingBar: [
        {
          name: "Llamadas entrantes por extensión",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesMiniCardOutgoingBar: [
        {
          name: "Llamadas salientes por extensión",
          data: [0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      dashboard_client_headers: [
        { text: "Cliente", value: "name", class: "primary--text" },
        { text: "Activos", value: "enable_count", class: "primary--text" },
        { text: "Inactivos", value: "disable_count", class: "primary--text" },
        { text: "Bloqueados", value: "unlock_count", class: "primary--text" },
        { text: "Login", value: "online_count", class: "primary--text" },
        {
          text: "Conectados",
          value: "connect_planta_count",
          class: "primary--text",
        },
        { text: "Pausa", value: "pause_count", class: "primary--text" },
      ],
      dashboard_client: [],
      dashboard_root: [],
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    welcomeCardHeight() {
      if (this.$vuetify.breakpoint.mobile) {
        return "200";
      } else {
        return "150";
      }
    },
  },

  watch: {
    isDark() {
      this.changeThemeChart();
    },
  },

  // created() {
  //   this.requestDashboard();
  // },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
    this.getDashboard2();
  },

  updated() {
    this.changeThemeChart();
  },

  methods: {
    requestDashboard() {
      let value = this.DateSearch;

      this.render = false;
      this.clearAllGraphics();

      switch (value) {
        case "Hoy":
          this.getDashboardDayValues();
          break;
        case "Ayer":
          this.getDashboardYesterdayValues();
          break;

        case "Mes Actual":
          this.getDashboardMonthValues();
          break;
        case "Mes Anterior":
          this.getDashboardMonthYesterdayValues();
          break;

        default:
          this.getDashboardDayValues();
          break;
      }
    },

    async getDashboardDayValues() {
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_DAY_VALUES",
          { yesterday: false, is_queue: this.QueueSearch }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
    },

    async getDashboardYesterdayValues() {
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_DAY_VALUES",
          { yesterday: true, is_queue: this.QueueSearch }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
    },

    async getDashboardMonthValues() {
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_MONTH_VALUES",
          { yesterday: false, is_queue: this.QueueSearch }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
    },

    async getDashboardMonthYesterdayValues() {
      try {
        const response = await this.$store.dispatch(
          "dashboard/DASHBOARD_MONTH_VALUES",
          { yesterday: true, is_queue: this.QueueSearch }
        );

        this.render = true;
        this.graphics(response.data);
      } catch (error) {
        this.$snotify.error(
          "No se pudo obtener las estadísticas del sistema.",
          "¡Error!"
        );
        // console.error(error);
      }
    },

    async getDashboard2() {
      const accessToken = localStorage.getItem("token");

      try {
        const res = await axios.all([
          axios.get(`${process.env.VUE_APP_ROOTAPI}/dashboard_client`, {
            headers: { Authorization: `Bearer ${accessToken}` },
          }),
          // axios.get(`${process.env.VUE_APP_ROOTAPI}/dashboard_root`, {
          //   headers: { Authorization: `Bearer ${accessToken}` },
          // }),
        ]);
        this.dashboard_client = res[0].data;
        // this.dashboard_root = res[1].data;
      } catch (error) {
        // console.error("Error de recordings", error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
    },

    graphics(response) {
      // Gráfica de Mini Cards Entrantes //
      // Área
      this.optionsMiniCardsAreaIncoming.title.text = response.starters;
      this.optionsMiniCardsAreaIncoming.xaxis.categories = response.graph3H;
      this.seriesMiniCardIncomingArea[0].data = response.graph3B;

      // Barras
      this.optionsMiniCardsBarIncoming.title.text =
        response.graph2Starters.data.length;
      this.seriesMiniCardIncomingBar[0].data = response.graph2Starters.data.map(
        function(value) {
          return value.total;
        }
      );
      this.optionsMiniCardsBarIncoming.xaxis.categories = response.graph2Starters.data.map(
        function(value) {
          return value.extension;
        }
      );

      // Gráfica de Mini Cards Salientes //
      // Área
      this.optionsMiniCardsAreaOutgoing.title.text = response.outgoing;
      this.optionsMiniCardsAreaOutgoing.xaxis.categories = response.graph3H;
      this.seriesMiniCardOutgoingArea[0].data = response.graph3A;

      //Barras
      this.optionsMiniCardsBarOutgoing.title.text =
        response.graph2Outgoing.data.length;
      this.seriesMiniCardOutgoingBar[0].data = response.graph2Outgoing.data.map(
        function(value) {
          return value.total;
        }
      );
      this.optionsMiniCardsBarOutgoing.xaxis.categories = response.graph2Outgoing.data.map(
        function(value) {
          return value.extension;
        }
      );

      // Fin mini cards //

      // Gráfica dona
      this.totalCalls = response.starters + response.outgoing;
      this.totalIncomingCalls = response.starters;
      this.totalOutgoingCalls = response.outgoing;
      this.serieDonut = [response.starters, response.outgoing];

      // Grafica de tres líneas (Entrantes y Salientes y Total)
      this.optionsLine.xaxis.categories = response.graph3H;
      this.serieLine[0].data = response.graph3B;
      this.serieLine[1].data = response.graph3A;
      this.serieLine[2].data = response.graph3C;

      // Gráfica de barras Entrantes
      this.optionsBarIncomingCalls.xaxis.categories = response.graph2Starters.data.map(
        function(value) {
          return value.extension;
        }
      );
      this.barIncomingCalls[0].data = response.graph2Starters.data.map(function(
        value
      ) {
        return value.total;
      });

      // Gráfica de barras Salientes
      this.optionsBarOutgoingCalls.xaxis.categories = response.graph2Outgoing.data.map(
        function(value) {
          return value.extension;
        }
      );
      this.barOutgoingCalls[0].data = response.graph2Outgoing.data.map(function(
        value
      ) {
        return value.total;
      });
    },

    clearAllGraphics() {
      this.serieLine = [
        {
          name: "Entrantes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Salientes",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ];

      this.optionsLine.xaxis.categories = [];
    },

    changeThemeChart() {
      if (this.$refs.chart1 !== undefined) {
        if (this.isDark) {
          this.$refs.chart1.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart2.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart3.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart4.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart5.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart6.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart7.updateOptions({ theme: { mode: "dark" } }, true);
          this.$refs.chart8.updateOptions({ theme: { mode: "dark" } }, true);
        } else {
          this.$refs.chart1.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart2.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart3.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart4.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart5.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart6.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart7.updateOptions({ theme: { mode: "light" } }, true);
          this.$refs.chart8.updateOptions({ theme: { mode: "light" } }, true);
        }
      }
    },
  },
};
</script>
